import { useCallback, useState } from "react";
import { useBackOrNavigate } from "../../../../../common/utils/navigateUtils";

import CommonConstants from "../../../../../common/constants";

/**
 * ObrasTopHeaderState
 */

export type ObrasTopHeaderState = {
  openIrParaModal: boolean;
  handleIrParaModalOpenState: (openState: boolean) => void;
  handleIrParaExecuteAction: (idAction: number, idObra: number | null, openNewTab: boolean) => void;
  handleIrParaIndicador: (idObra: number) => void;
};

/**
 * useObrasTopHeaderState
 */

export const useObrasTopHeaderState = (): ObrasTopHeaderState => {
  const [openIrParaModal, setOpenIrParaModal] = useState(false);

  const backOrNavigate = useBackOrNavigate();

  /**
   * Eventos
   */

  const handleIrParaModalOpenState = useCallback((openState: boolean) => {
    setOpenIrParaModal(openState);
  }, []);

  const handleIrParaExecuteAction = useCallback(
    (idAction: number, idObra: number | null, openNewTab: boolean) => {
      if (idObra) {
        switch (idAction) {
          case CommonConstants.obrasActions.informacoesGerais:
            if (openNewTab) {
              window.open(`/Obras_informacoesgerais?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_informacoesgerais?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.gestaoServicos:
            if (openNewTab) {
              window.open(`/Obras_gestao_servicos?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_gestao_servicos?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.checklistArea:
            if (openNewTab) {
              window.open(`/Obras_cadastroarea?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_cadastroarea?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.mapaConcretagem:
            if (openNewTab) {
              window.open(`/Obras_concretagem?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_concretagem?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.equipamentoMedicao:
            if (openNewTab) {
              window.open(`/Obras_equipamentosmedicao?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_equipamentosmedicao?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.equipamentoCritico:
            if (openNewTab) {
              window.open(`/Obras_maquinasequipamentos?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_maquinasequipamentos?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.treinamentos:
            if (openNewTab) {
              window.open(`/Obras_treinamentos?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_treinamentos?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.gestaoResiduos:
            if (openNewTab) {
              window.open(`/Obras_gestaoresiduos?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_gestaoresiduos?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.alvenariaEstrutural:
            if (openNewTab) {
              window.open(`/Obras_alvenariaestrutural?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_alvenariaestrutural?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.relacaoMateriaisControlados:
            backOrNavigate(`/Obras_materiaiscontrolados?id=${idObra}`);
            break;

          case CommonConstants.obrasActions.relacaoServicosControlados:
            backOrNavigate(`/Obras_servicoscontrolados?id=${idObra}`);
            break;

          case CommonConstants.obrasActions.sustentabilidade:
            if (openNewTab) {
              window.open(`/Obras_sustentabilidade?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_sustentabilidade?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;

          case CommonConstants.obrasActions.documentos:
            if (openNewTab) {
              window.open(`/Obras_documentos?id=${idObra}`, "_blank", "noopener,noreferrer");
            } else {
              backOrNavigate(`/Obras_documentos?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
            }
            break;
        }
      }
    },
    [backOrNavigate],
  );

  const handleIrParaIndicador = useCallback((idObra: number) => {
    backOrNavigate(`/IndicadoresServicosObras?id=${idObra}`, { replace: true, alternativeRoute: "/Obras_lista" });
  }, [
    backOrNavigate,
  ]);

  return {
    openIrParaModal,
    handleIrParaModalOpenState,
    handleIrParaExecuteAction,
    handleIrParaIndicador,
  };
};
